/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import { ReservationState } from '../state/ReservationState'
import MonthlyReportEvent from '../../event/MonthlyReportEvent'

class ReservationsStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return new ReservationState()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case MonthlyReportEvent.fetchAccommodationTaxDetail:
        return new ReservationState().mergeModelLocalDate(payload.reservation)

      default:
        return state
    }
  }
}

export default new ReservationsStore()
